// Locations mapped to regions in Ghana
// Format compatible with regions.js (using region names as keys)
const locations = {
  "Greater Accra": [
    "Accra",
    "Tema",
    "Korle-Bu",
    "Labadi",
    "Osu",
    "Cantonments",
    "East Legon",
    "West Legon",
    "Adenta",
    "Madina",
    "Ashaiman",
    "Teshie",
    "Nungua",
    "Dansoman",
    "Kaneshie",
    "Mallam",
    "Kasoa",
    "Weija",
    "Dzorwulu",
    "Airport Residential",
    "Other"
  ],
  "Ashanti": [
    "Kumasi",
    "Obuasi",
    "Ejisu",
    "Konongo",
    "Mampong",
    "Offinso",
    "Bekwai",
    "Juaso",
    "Asante Mampong",
    "Ejura",
    "Agogo",
    "Kumawu",
    "Effiduase",
    "Asokore",
    "Asokwa",
    "Suame",
    "Bantama",
    "Manhyia",
    "Other"
  ],
  "Western": [
    "Takoradi",
    "Sekondi",
    "Tarkwa",
    "Prestea",
    "Bogoso",
    "Axim",
    "Half Assini",
    "Elubo",
    "Enchi",
    "Bibiani",
    "Sefwi Wiawso",
    "Juaboso",
    "Asankragwa",
    "Wassa Akropong",
    "Other"
  ],
  "Eastern": [
    "Koforidua",
    "Akosombo",
    "Nkawkaw",
    "Mpraeso",
    "Aburi",
    "Akropong",
    "Begoro",
    "Kibi",
    "Asamankese",
    "Suhum",
    "Akuapem",
    "Kwahu",
    "Fanteakwa",
    "Other"
  ],
  "Volta": [
    "Ho",
    "Keta",
    "Anloga",
    "Kpando",
    "Hohoe",
    "Kadjebi",
    "Krachi",
    "Nkwanta",
    "Jasikan",
    "Kpeve",
    "Sogakope",
    "Akatsi",
    "Other"
  ],
  "Central": [
    "Cape Coast",
    "Kasoa",
    "Winneba",
    "Swedru",
    "Saltpond",
    "Mankessim",
    "Dunkwa",
    "Assin Foso",
    "Twifo Praso",
    "Abura Dunkwa",
    "Komenda",
    "Elmina",
    "Other"
  ],
  "Northern": [
    "Tamale",
    "Yendi",
    "Savelugu",
    "Kumbungu",
    "Tolon",
    "Nanton",
    "Saboba",
    "Chereponi",
    "Gushegu",
    "Karaga",
    "Mion",
    "Sagnerigu",
    "Other"
  ],
  "Upper East": [
    "Bolgatanga",
    "Bawku",
    "Navrongo",
    "Paga",
    "Bongo",
    "Talensi",
    "Nabdam",
    "Kassena Nankana",
    "Builsa",
    "Binduri",
    "Other"
  ],
  "Upper West": [
    "Wa",
    "Lawra",
    "Jirapa",
    "Nandom",
    "Lambussie",
    "Sissala East",
    "Sissala West",
    "Daffiama",
    "Other"
  ],
  "Western North": [
    "Sefwi Wiawso",
    "Bibiani",
    "Juaboso",
    "Bia",
    "Suaman",
    "Aowin",
    "Other"
  ],
  "Ahafo": [
    "Goaso",
    "Bechem",
    "Hwidiem",
    "Kenyasi",
    "Mim",
    "Other"
  ],
  "Bono": [
    "Sunyani",
    "Berekum",
    "Dormaa",
    "Wenchi",
    "Other"
  ],
  "Bono East": [
    "Techiman",
    "Atebubu",
    "Kintampo",
    "Nkoranza",
    "Sene",
    "Pru",
    "Other"
  ],
  "Oti": [
    "Dambai",
    "Kete Krachi",
    "Nkwanta",
    "Jasikan",
    "Kadjebi",
    "Other"
  ],
  "Savannah": [
    "Damongo",
    "Bole",
    "Sawla",
    "Tuna",
    "Other"
  ],
  "North East": [
    "Nalerigu",
    "Gambaga",
    "Walewale",
    "Yunyoo",
    "Other"
  ]
};

export default locations;
